import Money from '../shared/Money'
import PriceItemJson from 'src/models/pricing/interfaces/PriceItemJson'

export default class PriceItem {
  lockerTypeId: string
  periodIdentifier: string
  price: Money

  constructor(lockerTypeId: string, periodIdentifier: string, price: Money) {
    this.lockerTypeId = lockerTypeId
    this.periodIdentifier = periodIdentifier
    this.price = price
  }

  static fromJson(data: PriceItemJson) {
    return new this(
      data.lockerTypeId,
      data.periodIdentifier,
      Money.fromJson(data.price),
    )
  }
}
